import { formatarMoeda } from './formatadores'

export type PagamentoDoMotivo = {
	valor: number
	formaDePagamento?: string | null
}

export type DadosDoMotivoDeAutenticacao = {
	motivo: string
	cliente?: string | null
	valorDaVenda: number
	limiteDisponivel?: number
	limitePorCompra?: number
	limitesPorCompra?: PagamentoDoMotivo[]
	pagamentos?: PagamentoDoMotivo[]
}

const moeda = (valor: number) => `R$ ${formatarMoeda(Number(valor) || 0)}`
const comForma = (item: PagamentoDoMotivo) => item.formaDePagamento ? ` (${item.formaDePagamento})` : ''

export function montarMotivoDeAutenticacao(dados: DadosDoMotivoDeAutenticacao): string {
	const linhas = [`Motivo: ${dados.motivo}`]
	if (dados.cliente) linhas.push(`Cliente: ${dados.cliente}`)
	linhas.push(`Valor da venda: ${moeda(dados.valorDaVenda)}`)
	if (dados.limiteDisponivel !== undefined) linhas.push(`Limite disponível: ${moeda(Math.max(0, dados.limiteDisponivel))}`)
	if (dados.limitePorCompra !== undefined) linhas.push(`Limite por compra: ${moeda(dados.limitePorCompra)}`)
	for (const limite of dados.limitesPorCompra || []) {
		linhas.push(`Limite por compra: ${moeda(limite.valor)}${comForma(limite)}`)
	}
	for (const pagamento of dados.pagamentos || []) {
		linhas.push(`Pagamento: ${moeda(pagamento.valor)}${comForma(pagamento)}`)
	}
	return linhas.join('\n')
}
